import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { ContactForm } from '@/components/LazyContactForm';
import { useContactForm } from '@/hooks/useContactForm';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isContactFormOpen, openContactForm, closeContactForm } = useContactForm();

  const handleNavClick = (href: string) => {
    // Close mobile menu
    setIsMobileMenuOpen(false);
    
    // Smooth scroll with offset for header
    const element = document.querySelector(href) as HTMLElement;
    if (element) {
      const headerOffset = 80; // Offset for fixed header
      const elementPosition = element.offsetTop;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="relative z-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/lovable-uploads/5871818a-0dcf-43d8-8d23-72d7c71a6da2.png" 
              alt="Scale AI Logo" 
              className="h-20 w-auto sm:h-24 md:h-32 lg:h-36"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => handleNavClick('#funcionalidades')} 
              className="text-muted-foreground hover:text-foreground transition-smooth py-2 px-1 min-h-[24px] min-w-[24px] flex items-center"
            >
              Como funciona
            </button>
            <button 
              onClick={() => handleNavClick('#demonstracao')} 
              className="text-muted-foreground hover:text-foreground transition-smooth py-2 px-1 min-h-[24px] min-w-[24px] flex items-center"
            >
              Demonstração
            </button>
            <button 
              onClick={() => handleNavClick('#resultados')} 
              className="text-muted-foreground hover:text-foreground transition-smooth py-2 px-1 min-h-[24px] min-w-[24px] flex items-center"
            >
              Resultados
            </button>
            <button 
              onClick={() => handleNavClick('#faq')} 
              className="text-muted-foreground hover:text-foreground transition-smooth py-2 px-1 min-h-[24px] min-w-[24px] flex items-center"
            >
              FAQ
            </button>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center">
            <Button variant="hero" size="lg" onClick={openContactForm}>
              Falar com Especialista
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-muted-foreground hover:text-foreground transition-smooth"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? "Fechar menu" : "Abrir menu"}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-card border border-border rounded-lg mx-4 mt-2 shadow-soft">
            <nav className="flex flex-col p-6 gap-4">
              <button 
                onClick={() => handleNavClick('#funcionalidades')} 
                className="text-muted-foreground hover:text-foreground py-2 transition-smooth text-left"
              >
                Como funciona
              </button>
              <button 
                onClick={() => handleNavClick('#demonstracao')} 
                className="text-muted-foreground hover:text-foreground py-2 transition-smooth text-left"
              >
                Demonstração
              </button>
              <button 
                onClick={() => handleNavClick('#resultados')} 
                className="text-muted-foreground hover:text-foreground py-2 transition-smooth text-left"
              >
                Resultados
              </button>
              <button 
                onClick={() => handleNavClick('#faq')} 
                className="text-muted-foreground hover:text-foreground py-2 transition-smooth text-left"
              >
                FAQ
              </button>
              <div className="flex justify-center pt-4 border-t border-border">
                <Button variant="hero" size="lg" className="w-full" onClick={openContactForm}>
                  Falar com Especialista
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
      
      <ContactForm isOpen={isContactFormOpen} onClose={closeContactForm} />
    </header>
  );
};

export default Header;